import React, { useEffect, useState, } from 'react';
import '../admin.list.scss';
import { useTranslation, } from 'react-i18next';
import { useNavigate, } from 'react-router-dom';
import { ColumnsType, SorterResult, } from 'antd/lib/table/interface';
import { IPreviewVoiceAsteriskDowngrade, PermissionEnum, CrudEnum, TVoiceAsteriskDowngradeSortableListCol, } from 'atlas-shared';
import { Table, } from 'antd';
import { AdminListPageHeader, ListPageEmpty, } from '@Components';
import { IWithListProps, IWithListSorterProps, withList, } from '@Hocs/with.list';
import { useAbilities, useAuth, useVoiceAsteriskDowngrades, useOrganizations, } from '@Hooks';
import { VoiceAsteriskDowngradeListColumns, } from '@Utils';
import { IAuth, } from '@Store';

const VoiceAsteriskDowngradeList = ({ filters, filtersCount, hasFilters, sorter, pagination, setQueryParams, resetQueryParams, }: IWithListProps<IPreviewVoiceAsteriskDowngrade, TVoiceAsteriskDowngradeSortableListCol>) => {
  const { t, } = useTranslation();
  const navigate = useNavigate();
  const auth: IAuth = useAuth();
  const voice_asterisk_downgrades = useVoiceAsteriskDowngrades();
  const abilities = useAbilities();
  const [loading, setLoading, ] = useState<boolean>(true);
  const [rows, setRows, ] = useState<Array<any>>([]);
  const organizations = useOrganizations();
  
  const [showDeleted, setShowDeleted, ] = useState(false);
  const [deletedCount, setDeletedCount, ] = useState<number>(0);
  
  useEffect(() => {
    if (!voice_asterisk_downgrades.loaded)
      return;
      
    setLoading(false);
    setRows((!showDeleted ? voice_asterisk_downgrades.voice_asterisk_downgrades.filter(p => !p.deleted_at) : voice_asterisk_downgrades.voice_asterisk_downgrades || []).map(row => ({ ...row, key: row.id, })));
    setDeletedCount(voice_asterisk_downgrades.voice_asterisk_downgrades.filter(voice_asterisk_downgrade => !!voice_asterisk_downgrade.deleted_at).length);
  }, [voice_asterisk_downgrades, showDeleted, ]);

  const columns: ColumnsType<IPreviewVoiceAsteriskDowngrade> = React.useMemo(() => {
    return VoiceAsteriskDowngradeListColumns(t, navigate, showDeleted, organizations, abilities, auth, [], filters, sorter);
  }, [t, navigate, showDeleted, organizations, abilities, auth, filters, sorter, ]);

  return <div className='admin-list-view'>
    <AdminListPageHeader 
      t={t}
      title={t('VOICE_ASTERISK_DOWNGRADES')}
      filtersCount={filtersCount}
      reset={() => resetQueryParams()}
      deleted={[showDeleted, setShowDeleted, ]} deletedCount={deletedCount}
      addBtn={abilities.canImplicit(null, CrudEnum.Insert, PermissionEnum.VoiceAsterisk) ? { callback: () => navigate('/admin/voice_asterisk_downgrade/add'), } : undefined} 
    />
    <div className='table-wrp'>
      <Table
        key={loading ? 1 : 0}
        columns={columns}
        dataSource={rows}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
        }}
        onChange={(pagination, filters, _sorter) => {
          const sorter: Array<SorterResult<any>> = Array.isArray(_sorter) ? _sorter : _sorter?.columnKey ? [_sorter, ] : [];

          setQueryParams({
            pagination: { current: pagination.current as number, pageSize: pagination.pageSize as number, },
            filters: Object.fromEntries(Object.entries(filters).filter(([key, value, ]) => value !== null)),
            sorter: sorter
              .filter(s => !!s.order)
              .map(s => ({ column: s.columnKey as TVoiceAsteriskDowngradeSortableListCol, order: s.order as IWithListSorterProps<IPreviewVoiceAsteriskDowngrade, TVoiceAsteriskDowngradeSortableListCol>['order'], })),
          });
        }}
        locale={{
          emptyText: <ListPageEmpty t={t} hasFilters={hasFilters} hasRows={!!rows.length} reset={() => resetQueryParams()} />,
        }}
      />
    </div>
  </div>;
};

export const VoiceAsteriskDowngradeListView = React.memo(withList<IPreviewVoiceAsteriskDowngrade, TVoiceAsteriskDowngradeSortableListCol>(VoiceAsteriskDowngradeList, {
  filters: {},
  sorter: [{ column: 'created_at', order: 'descend', }, ],
  pagination: { current: 1, pageSize: 10, },
}));
